import type { InternalRangeItem } from '../types/range-legend.internal.js';
import type { RangeItem } from '../types/range-legend.js';
import { isSingleRangeHandler } from './is-single-range-handler.js';

export const getInternalRangeItems = (
  items: RangeItem[],
): InternalRangeItem[] => {
  const isSingleRange = isSingleRangeHandler(items);

  return items.map<InternalRangeItem>((item) => {
    let { from: itemFrom, to: itemTo } = item;

    if (isSingleRange) {
      const isInfiniteRange = itemFrom === -Infinity && itemTo === Infinity;
      const isSinglePointRange = itemFrom === itemTo;

      if (isInfiniteRange) {
        itemFrom = 0;
        itemTo = 1;
      }

      if (isSinglePointRange) {
        itemTo = itemFrom + 1;
      }
    }

    return {
      ...item,
      from: itemFrom,
      to: itemTo,
      labels: { from: item.from.toString(), to: item.to.toString() },
    };
  });
};
